import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, EffectFade } from 'swiper';
import { Link } from 'react-router-dom';
import './HeroBanner.css';
import 'swiper/css';
import 'swiper/css/effect-fade';

import banner1 from '../../images/slider/banner1.png';
import banner2 from '../../images/slider/banner2.jpeg';
import banner3 from '../../images/slider/banner3.png';

const slides = [
    {
        image: banner1,
        tag: 'Derechos humanos',
        title: 'Promovemos dignidad, educación y protección para las comunidades.',
        subtitle: 'Trabajamos desde la educación en derechos humanos para fortalecer a niñas, niños, familias y poblaciones vulnerables.',
    },
    {
        image: banner2,
        tag: 'Intervención social',
        title: 'Impulsamos procesos comunitarios que generan oportunidades reales.',
        subtitle: 'Acompañamos territorios con acciones sociales, pedagógicas y comunitarias orientadas al bienestar y la inclusión.',
    },
    {
        image: banner3,
        tag: 'Acción colectiva',
        title: 'Construimos un país más justo junto a quienes más lo necesitan.',
        subtitle: 'Con aliados, voluntariado y trabajo en red, defendemos derechos y promovemos desarrollo comunitario con impacto social.',
    },
];

const HeroBanner = () => {
    return (
        <div className="hero-banner-wrap">
            <Swiper
                modules={[Autoplay, EffectFade]}
                effect="fade"
                autoplay={{ delay: 4500, disableOnInteraction: false }}
                speed={1200}
                loop={true}
                className="hero-banner-swiper"
            >
                {slides.map((slide, i) => (
                    <SwiperSlide key={i}>
                        <div
                            className="hero-banner-slide"
                            style={{ backgroundImage: `url(${slide.image})` }}
                        >
                            <div className="hero-banner-overlay" />
                            <div className="container">
                                <div className="hero-banner-content">
                                    <span className="hero-banner-tag">{slide.tag}</span>
                                    <h1 className="hero-banner-title">{slide.title}</h1>
                                    <p className="hero-banner-sub">{slide.subtitle}</p>
                                    <div className="hero-banner-btns">
                                        <Link to="/about" className="btn theme-btn-s2">Conócenos</Link>
                                        <Link to="/cause" className="btn hero-banner-btn-outline">Nuestros proyectos</Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>

            {/* Onda blanca de transición al contenido inferior */}
            <div className="hero-banner-wave">
                <svg viewBox="0 0 1440 90" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0,50 C200,90 400,20 600,55 C800,90 1050,15 1200,50 C1300,70 1380,55 1440,50 L1440,90 L0,90 Z" fill="#ffffff" />
                </svg>
            </div>
        </div>
    );
};

export default HeroBanner;
